<template>
  <div
    class="filedrop"
    @dragover.prevent="isDragOver = true"
    @dragleave.prevent="isDragOver = false"
    @drop.prevent="fileDrop"
    :style="{ background: isDragOver ? 'rgba(0, 66, 105, 0.05)' : '', height }"
  >
    <div class="text">Загрузите файлы простым переносом или по кнопке ниже</div>
    <Button
      icon="attach"
      iconWidth="14px"
      width="150px"
      height="32px"
      text="Загрузить"
      class="btn-secondary"
      style="font-size: 14px; margin-top: 12px"
      @click.native.prevent="$refs.file.click()"
    />
    <input
      type="file"
      ref="file"
      @change="hanfleUpload"
      hidden
      :accept="accept"
      multiple
    />
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "VFiledrop",
  components: {
    Button,
  },
  props: {
    accept: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "122px",
    },
  },
  data() {
    return {
      isDragOver: false,
    };
  },
  methods: {
    hanfleUpload({ target }) {
      for (let index = 0; index < target.files.length; index++) {
        this.$emit("upload", target.files[index]);
      }
    },
    fileDrop(e) {
      for (let index = 0; index < e.dataTransfer.files.length; index++) {
        const file = e.dataTransfer.files[index];
        if (this.accept && file.type.includes(this.accept)) {
          this.$emit("upload", e.dataTransfer.files[index]);
        } else if (
            file.type.includes("application/pdf") ||
            file.type.includes("image/")
        ) {
          this.$emit("upload", e.dataTransfer.files[index]);
        } else {
          // Promise.reject("Тип файла не поддерживается");
          this.$root.popup("Некорректный формат файла", "", "info");
        }
      }

      this.isDragOver = false;
    },
  },
};
</script>

<style scoped lang="scss">
.filedrop {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 23px;
  color: rgba(0, 32, 51, 0.6);
  position: relative;
  border: 2px dashed $gray;
  border-radius: 8px;
  transition: 0.2s;
  text-align: center;

  .text {
    width: 306px;
  }
}
</style>
